import SectionArticle from './SectionArticle';
export default SectionArticle;
